"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerPlatformBase = void 0;
const eventemitter3_1 = require("eventemitter3");
/** A sub-class of WorkerPlatformBase handles the communication with a child process */
class WorkerPlatformBase extends eventemitter3_1.EventEmitter {
    constructor() {
        super(...arguments);
        this._isFakeProcess = false;
    }
    get isFakeProcess() {
        return this._isFakeProcess;
    }
}
exports.WorkerPlatformBase = WorkerPlatformBase;
//# sourceMappingURL=_base.js.map